/**
 * The pieces of the onboarding modals' brand band that their hosts need, rather than the band
 * itself: `BrandModalHeader.vue` renders that, and `_brand-modal.scss` paints it.
 *
 * A host needs two things it cannot get from the child component. The band paints `.modal-header`,
 * which Bootstrap Vue renders itself and only exposes through `header-class`; and the entrance
 * stagger runs down past the band into the modal's own body, so the host times its own elements.
 */

/** The class that runs the entrance animation. Absent means "visible, and not animating". */
export const BRAND_MODAL_RISE = "brand-modal-rise";

/** What Bootstrap Vue has to put on `.modal-header` for the band to paint. */
export function brandModalHeaderClass(sandboxMode: boolean): (string | Record<string, boolean>)[] {
    return ["brand-modal-header", { "brand-modal-header--trial": sandboxMode }];
}

/**
 * What Bootstrap Vue has to put on `.modal-content` so the band's tone reaches the actions inside
 * it. Separate from the header class because Bootstrap Vue exposes the two elements separately.
 */
export function brandModalContentClass(sandboxMode: boolean): (string | Record<string, boolean>)[] {
    return ["brand-modal", { "brand-modal--trial": sandboxMode }];
}

/**
 * Per-element delay for the stagger, as an inline style. Inert while `BRAND_MODAL_RISE` is absent,
 * which is why a host can set it unconditionally.
 */
export function brandModalRiseDelay(ms: number): Record<string, string> {
    return { animationDelay: `${ms}ms` };
}
